import React, { MouseEventHandler } from 'react';

import { NavLink, NavLinkPropsT } from '@consumer-frontend/shared-ui';

export type NcNavLinkT = React.FC<NavLinkPropsT & { onClick?: MouseEventHandler; }>;

export const NcNavLink: NcNavLinkT = (props) => {
  return <NavLink {...props} />;
};
